import React, { Component } from "react";
import FixedOptions from "./FixedOptions/FixedOptions";
import AcquirorsOptions from "./AcquirorsOptions/AcquirorsOptions";
import AcquireesOptions from "./AcquireesOptions/AcquireesOptions";
import CustomersOptions from "./CustomersOptions/CustomersOptions";
import "./PanelLeft.css";

class PanelLeft extends Component {
	render() {
		// type of search query
		let queryType = this.props.query.type;
		let queryTypeSingular = this.props.query.type.slice(0, -1);

		return (
			<div className="panel-left">
				<FixedOptions
					countries={this.props.countries}
					queryTypeSingular={queryTypeSingular}
					query={this.props.query}
					//industries={this.props.industries}
					searchProducts={this.props.searchProducts}
					addSearchTypeToQuery={this.props.addSearchTypeToQuery}
					buildSearchQuery={this.props.buildSearchQuery}
				/>
				{queryType === "acquirers" && (
					<AcquirorsOptions
						query={this.props.query}
						queryTypeSingular={queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}
				{queryType === "targets" && (
					<AcquireesOptions
						query={this.props.query}
						queryTypeSingular={queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}
				{queryType === "customers" && (
					<CustomersOptions
						query={this.props.query}
						queryTypeSingular={queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}
				<label><a href="https://www.fmeasure.com/user-instructions" target="_blank"><u>User Instructions</u></a></label>
			</div>
		);
	}
}

export default PanelLeft;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/PanelLeft.js